export default __webpack_public_path__ + "static/2.2_DE-b3f768391f56dbc7863e8c1feaa7221d.webp";